const makeDefaultActiveFilters = (initFilters) => initFilters.map(({ field }) => ({ field, values: [] }));

export default makeDefaultActiveFilters;
